import axios from 'axios'
import { logout } from './authSlice'

const API_URL = '/users/'

// Register user
const register = async (userData) => {
  const response = await axios.post(API_URL, userData)

  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data))
  }

  return response.data
}

// Login user
const login = async (userData) => {
  const response = await axios.post(API_URL + 'login', userData)

  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data))
  }

  return response.data
}

// Logout user
const logoutUser = () => {
  localStorage.removeItem('user')
}

// Axios interceptor to handle token expiration
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Remove user from localStorage
      localStorage.removeItem('user')

      // Optionally, redirect to login page
      window.location.href = '/login'

      // Dispatch logout action if using Redux
      if (typeof logout === 'function') {
        logout()
      }
    }
    return Promise.reject(error)
  }
)

const authService = {
  register,
  login,
  logout: logoutUser,
}

export default authService